import styled, { keyframes } from 'styled-components'

export const eat = keyframes`
0% {
    clip-path: polygon(100% 74%, 44% 48%, 100% 21%);
  }
  25% {
    clip-path: polygon(100% 60%, 44% 48%, 100% 40%);
  }
  50% {
    clip-path: polygon(100% 50%, 44% 48%, 100% 50%);
  }
  75% {
   clip-path: polygon(100% 59%, 44% 48%, 100% 35%);
  }
  100% {
   clip-path: polygon(100% 74%, 44% 48%, 100% 21%);
  }
`

export const food = keyframes`
0% {
    transform: translateX(0);
     opacity: 1;
  }
  100% {
    transform: translateX(-50px);
    opacity: 0;
  }
`

export const Container = styled.div`
    background-color: white;
    width: 500px;
    height: 280px;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin-top: -35px;
`

export const Heading = styled.h1`
    font-size: 20px;
    margin-top: 35px;
    position: relative;
    color: #e87d7c;
    font-family: Avenir;
    width: 100%;
    text-align: center;
`
export const PacManContainer = styled.div`
    float: left;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -25px;
`

export const PacMan = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #e87d7c;
    position: relative;
    left: -60px;
`

export const PacManMouth = styled.div`
    background: #fff;
    position: absolute;
    width: 100%;
    height: 100%;
    clip-path: polygon(100% 74%, 44% 48%, 100% 21%);
    animation-name: ${eat};
    animation-duration: 2s;
    animation-iteration-count: infinite;
`
export const PacManFoodStart = styled.div`
    position: absolute;
    width: 15px;
    height: 15px;
    background: #58b7e6;
    border-radius: 50%;
    top: 40%;
    left: 120px;
    animation-name: ${food};
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
`
export const PacManFoodMiddle = styled.div`
    position: absolute;
    width: 15px;
    height: 15px;
    background: #95c48c;
    border-radius: 50%;
    top: 40%;
    left: 150px;
    animation-name: ${food};
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
`
export const PacManFoodEnd = styled.div`
    position: absolute;
    width: 15px;
    height: 15px;
    background: #f3c520;
    border-radius: 50%;
    top: 40%;
    left: 180px;
    animation-name: ${food};
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
`
